import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  firstName: string = '';
  email: string = '';
  phoneNumber: string = '';
  password: string = '';
  department: string = '';
  isAdmin: boolean = false;
  source: string = 'WEB';

  states: any[] = [];
  districts: any[] = [];
  blocks: any[] = [];

  selectedState: any = null;
  selectedDistrict: any = null;
  selectedBlock: any = null;

  loadingStates: boolean = false;
  showBulkActions: boolean = false;
  showPassword: boolean = false;
  private metaStateUUID: string | null = null;
  private metaDistrictUUID: string | null = null;
  private metaBlockUUID: string | null = null;

  isStateRestricted: boolean = false;
  isDistrictRestricted: boolean = false;
  isBlockRestricted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private heatwaveDataSrv: HeatwaveDataService,
    private toastr: ToastrService,
    private http: HttpClient
  ) { }
  // ngOnInit() {
  //   const metaRaw = localStorage.getItem('metaInfo');
  //   const metaInfo = metaRaw ? JSON.parse(metaRaw) : null;
  //   const locType = (metaInfo && metaInfo.userDetailsJson && metaInfo.userDetailsJson.data
  //     ? metaInfo.userDetailsJson.data.locType : '').toUpperCase();

  //   if (locType === 'STATE') {
  //     const stateEntry = metaInfo.userDetailsJson.data.location &&
  //       metaInfo.userDetailsJson.data.location.country &&
  //       metaInfo.userDetailsJson.data.location.country[0] &&
  //       metaInfo.userDetailsJson.data.location.country[0].state &&
  //       metaInfo.userDetailsJson.data.location.country[0].state[0];
  //     this.metaStateUUID = stateEntry ? stateEntry.stateUUID : null;
  //   }

  //   const paramsRaw = sessionStorage.getItem('params');
  //   const sessionParams = paramsRaw ? JSON.parse(paramsRaw) : null;
  //   const sessionLocType = sessionParams ? sessionParams.locType : '';
  //   this.showBulkActions = sessionLocType !== 'COUNTRY';

  //   this.fetchStates();
  // }


  ngOnInit() {
    const metaRaw = localStorage.getItem('metaInfo');
    const metaInfo = metaRaw ? JSON.parse(metaRaw) : null;
    const locType = (metaInfo && metaInfo.userDetailsJson && metaInfo.userDetailsJson.data
      ? metaInfo.userDetailsJson.data.locType : '').toUpperCase();

    const countryData = metaInfo && metaInfo.userDetailsJson && metaInfo.userDetailsJson.data &&
      metaInfo.userDetailsJson.data.location && metaInfo.userDetailsJson.data.location.country &&
      metaInfo.userDetailsJson.data.location.country[0];

    if (countryData && countryData.state && countryData.state[0]) {
      const stateEntry = countryData.state[0];
      this.metaStateUUID = stateEntry.stateUUID || null;

      if (stateEntry.district && stateEntry.district[0]) {
        const districtEntry = stateEntry.district[0];
        this.metaDistrictUUID = districtEntry.districtUUID || null;

        if (districtEntry.block && districtEntry.block[0]) {
          const blockEntry = districtEntry.block[0];
          this.metaBlockUUID = blockEntry.blockUUID || null;
        }
      }
    }

    const paramsRaw = sessionStorage.getItem('params');
    const sessionParams = paramsRaw ? JSON.parse(paramsRaw) : null;
    const sessionLocType = sessionParams ? sessionParams.locType : '';
    this.showBulkActions = sessionLocType !== 'COUNTRY';

    this.isStateRestricted = !!this.metaStateUUID;
    this.isDistrictRestricted = !!this.metaDistrictUUID;
    this.isBlockRestricted = !!this.metaBlockUUID;

    this.fetchStates();
  }

  fetchStates() {
    this.loadingStates = true;
    this.heatwaveDataSrv.getAllChildLocationList('00cb31c7-2928-4e6d-adcc-443d478c90d6', 'COUNTRY', 'STATE').subscribe(data => {
      if (data) {
        if (this.metaStateUUID) {
          this.states = data.filter((s: any) => s.lUUID === this.metaStateUUID);
          if (this.states.length === 1) {
            this.selectedState = this.states[0];
            this.onStateChange();
          }
        } else {
          this.states = data;
        }
      }
      this.loadingStates = false;
    }, () => {
      this.loadingStates = false;
    });
  }

  onStateChange() {
    this.districts = [];
    this.selectedDistrict = null;
    this.blocks = [];
    this.selectedBlock = null;
    if (this.selectedState) {
      this.heatwaveDataSrv.getAllChildLocationList(this.selectedState.lUUID, 'STATE', 'DISTRICT').subscribe(data => {
        if (data) {
          if (this.metaDistrictUUID) {
            this.districts = data.filter((d: any) => d.lUUID === this.metaDistrictUUID);
            if (this.districts.length === 1) {
              this.selectedDistrict = this.districts[0];
              this.onDistrictChange();
            }
          } else {
            this.districts = data;
          }
        }
      });
    }
  }

  onDistrictChange() {
    this.blocks = [];
    this.selectedBlock = null;
    if (this.selectedDistrict) {
      this.heatwaveDataSrv.getAllChildLocationList(this.selectedDistrict.lUUID, 'DISTRICT', 'BLOCK').subscribe(data => {
        if (data) {
          if (this.metaBlockUUID) {
            this.blocks = data.filter((b: any) => b.lUUID === this.metaBlockUUID);
            if (this.blocks.length === 1) {
              this.selectedBlock = this.blocks[0];
            }
          } else {
            this.blocks = data;
          }
        }
      });
    }
  }

  downloadTemplate() {
    const paramsRaw = sessionStorage.getItem('params');
    const params = paramsRaw ? JSON.parse(paramsRaw) : null;
    const locName = params ? params.locName : null;

    let fileName: string | null = null;
    const locNameUpper = (locName || '').toUpperCase().replace(/\s+/g, '_');
    // if (locNameUpper === 'BIHAR') {
    //   fileName = 'BIHAR.xlsx';
    // } else if (locNameUpper === 'UTTAR_PRADESH') {
    //   fileName = 'UTTAR_PRADESH.xlsx';
    // }
        if (locName === 'Bihar') {
      fileName = 'BIHAR.xlsx';
    } else if (locName === 'Uttar Pradesh') {
      fileName = 'UTTAR_PRADESH.xlsx';
    }

    if (!fileName) {
      this.toastr.warning('No template available for your location.');
      return;
    }

    const link = document.createElement('a');
    link.href = `assets/templates/${fileName}`;
    link.download = fileName;
    link.click();
  }

  onExcelFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;
    const file = input.files[0];
    input.value = '';

    const formData = new FormData();
    formData.append('file', file);

    const url = environment.url.HEATWAVE_STAGING_API_URL + 'ugmt/createUserFromExcel';
    this.http.post<any>(url, formData).subscribe(res => {
      this.toastr.success('Users created successfully from Excel.');
    }, err => {
      this.toastr.error('Failed to upload Excel. Please try again.');
    });
  }

  onSubmit() {
    if (!this.firstName || !this.email || !this.phoneNumber || !this.password || !this.selectedState) {
      this.toastr.warning('Please fill all mandatory fields.');
      return;
    }

    const locType = this.selectedBlock ? 'BLOCK' : (this.selectedDistrict ? 'DISTRICT' : 'STATE');
    const locName = this.selectedBlock ? this.selectedBlock.ln : (this.selectedDistrict ? this.selectedDistrict.ln : this.selectedState.ln);
    const locUuid = this.selectedBlock ? this.selectedBlock.lUUID : (this.selectedDistrict ? this.selectedDistrict.lUUID : this.selectedState.lUUID);

    const payload = {
      email: this.email,
      phoneNumber: this.phoneNumber,
      password: this.password,
      locType: locType,
      locName: locName,
      locUuid: locUuid,
      isAdmin: String(this.isAdmin).toUpperCase(),
      source: this.source,
      firstName: this.firstName,
      department: this.department
    };

    const url = environment.url.HEATWAVE_STAGING_API_URL + 'ugmt/createUser';
    this.http.post<any>(url, payload).subscribe(res => {
      if (res) {
        this.toastr.success(res);
        this.activeModal.close('Submit');
      } else {
        this.toastr.error('Something went wrong. Please try again.');
      }
    }, err => {
      this.toastr.error('Error occurred while creating user.');
    });
  }
}
